import type { DehydratedState, VueQueryPluginOptions } from '@tanstack/vue-query'
import { QueryClient, VueQueryPlugin, dehydrate, hydrate } from '@tanstack/vue-query'

import { useState } from '#app'
import { QUERY_CACHE_TIME } from '~/constants'

export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>('vue-query')

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_CACHE_TIME,
        gcTime: QUERY_CACHE_TIME,
        retry: import.meta.env.PROD ? 3 : 0,
        refetchOnWindowFocus: !!import.meta.env.PROD,
      },
    },
  })
  const options: VueQueryPluginOptions = { queryClient }

  nuxt.vueApp.use(VueQueryPlugin, options)

  if (process.server) {
    nuxt.hooks.hook('app:rendered', () => {
      vueQueryState.value = dehydrate(queryClient)
    })
  }

  if (process.client) {
    nuxt.hooks.hook('app:created', () => {
      hydrate(queryClient, vueQueryState.value)
      window.__TANSTACK_QUERY_CLIENT__ = queryClient
    })
  }
})
